<template>
  <section class="preview-pane">
    <div class="live-preview" :style="editPreviewStyle">
      <div class="preview-shade"></div>
      <div class="preview-content">
        <div class="brief-heading">
          <span>LIVE PREVIEW</span>
          <small>Level {{ editForm.levelNum || editForm.id }}</small>
        </div>
        <h2>{{ editForm.title || editForm.name || '未命名层级' }}</h2>
        <p>{{ editForm.description || '这里会实时展示你正在编辑的层级简介。' }}</p>
        <div class="preview-cover-card">
          <div>
            <span class="eyebrow">Cover Image</span>
            <strong>{{ editForm.img ? '封面图已载入' : '等待上传封面图' }}</strong>
          </div>
          <div class="preview-cover-img" :style="editCoverStyle">
            <span v-if="!editCoverUrl">封面图</span>
          </div>
        </div>
        <div class="metrics preview-metrics">
          <div>
            <span>状态</span>
            <strong>{{ statusText(Number(editForm.status || 0)) }}</strong>
          </div>
          <div>
            <span>访问</span>
            <strong>{{ editForm.enterNum || 0 }}</strong>
          </div>
          <div>
            <span>留言</span>
            <strong>{{ editForm.messageNum || 0 }}</strong>
          </div>
          <div>
            <span>收藏</span>
            <strong>{{ editForm.favoriteNum || 0 }}</strong>
          </div>
          <div>
            <span>上次巡逻</span>
            <strong>{{ formatDate(editForm.guardedAt) }}</strong>
          </div>
        </div>
        <div class="patrol-strip editor-patrol-tip">
          <span>连续 {{ patrolExpireDays }} 天未巡逻后，该层级将自动变为无主层级。</span>
        </div>
        <div v-if="editForm.auditStatus === 1" class="audit-tip">当前修改正在等待管理员审核，通过后才会对其他用户可见。</div>
        <div v-if="editForm.auditStatus === 3" class="audit-tip reject">上次审核被驳回：{{ editForm.rejectReason || '请修改后重新提交。' }}</div>
        <div v-if="editForm.notice" class="notice">{{ editForm.notice }}</div>
        <section v-if="previewHtml" class="level-html preview-html" v-html="previewHtml"></section>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { LevelItem } from './types';

defineProps<{
  editForm: Partial<LevelItem>;
  editPreviewStyle: Record<string, string>;
  editCoverStyle: Record<string, string>;
  editCoverUrl: string;
  patrolExpireDays: number;
  previewHtml: string;
}>();

const statusText = (status: number) => {
  if (status === 1) return '已占领';
  if (status === 2) return '待上线';
  if (status === -1) return '已删除';
  return '未占领';
};

const formatDate = (value?: string) => {
  if (!value) return '暂无';
  return String(value).replace('T', ' ').slice(0, 19);
};
</script>
